import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGear} from "@fortawesome/pro-solid-svg-icons/faGear";
import React from "react";
import {MailActionsIconMap} from "../../../Data/MailActionsIconMap";
import { MailActionsType } from "@twigsby/client-data";
import {ContentLoader, ItemMenuEntry} from "@twigsby/frontend-framework";
import {useMailbox} from "../../../Providers/NewMailboxProvider";


const MailActionMenu = (props: MailActionsType) => {
    const { mailItemActionsStatus, selectionActions } = useMailbox();

    return (
        <>
            {mailItemActionsStatus === 'loading' ? (
                <ContentLoader childHeight={'3em'} childCount={4} />
            ) : (!selectionActions || selectionActions.length === 0) ? (
                <div className={'flex-column align-center justify-center faded p-md'}>
                    <FontAwesomeIcon icon={faGear} fixedWidth={true} size={"2x"} />
                    <h6 className={'sm-sub-heading mt-sm mb-0'}>No Actions Available</h6>
                </div>
            ) : (
                <>
                    {selectionActions?.map((action: any, index: number) =>
                        !action.disabled && <ItemMenuEntry key={index} icon={MailActionsIconMap[action.name]} disabled={action.disabled} title={action.name} onClick={() => props.actionCallback ? props.actionCallback(action.transitionId) : null} />
                    )}
                </>
            )}
        </>
    )
}

export default MailActionMenu
